import { z } from 'zod';

export const MarketMapReportRequestSchema = z.object({
  brandId: z.string().uuid().optional(),
  marketCodes: z.array(z.string()).optional(),
  country: z.string().optional(),
  onlyPublished: z.boolean().optional(),
  labelIds: z.array(z.string().uuid()).optional(),
  classificationValues: z.array(z.string()).optional(),
  // avoid importing ReportFormat here — circular dep with report.ts; values match ReportFormat.CSV/PDF
  format: z.enum(['csv', 'pdf']).optional(),
});

export type MarketMapReportRequest = z.infer<typeof MarketMapReportRequestSchema>;

export const MarketMapReportWithHeaderSchema = z.record(z.string(), z.string());

export type MarketMapReportWithHeader = z.infer<typeof MarketMapReportWithHeaderSchema>;
